import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "src/app/service/apiServices";
import * as $ from "jquery";
import { Global } from "../../../global";
import { Location } from "@angular/common";
import { catchError, filter } from "rxjs/operators";
import { AuthService } from "../../../service/auth/auth.service";
import Swal from "sweetalert2";
import { FileUploadService } from "src/app/service/fileService";
declare var bootstrap: any;

@Component({
  selector: "app-painel-de-midia",
  templateUrl: "./painel-de-midia.component.html",
  styleUrls: ["./painel-de-midia.component.css"],
})
export class PainelDeMidiaComponent implements OnInit {
  painelMidiaelecimento_id: any = 0;
  listaBloco: any = [];
  listaClinica: any = [];
  painelMidia: any = {};
  uid: any = null;
  loading: any = false;

  // Upload previews / filenames
  logoSuperiorPreview: string | null = null;
  logoInferiorPreview: string | null = null;
  logoSuperiorFileName: string | null = null;
  logoInferiorFileName: string | null = null;

  videos: any = [];
  listaPlayLists: any = [];

  salasDisponiveis: any[] = [];
  salasSelecionadas: any[] = []; // IDs das salas já associadas ao painel
  estabelecimentoId: any = 0; // pode vir da store ou rota
  listaEstabelecimentos: any = [];
  salasAssociadasAoPainel: any[] = []; // Salas associadas ao painel de mídia

  constructor(
    private route: ActivatedRoute,
    public service: ApiService,
    private router: Router,
    private global: Global,
    private location: Location,
    private authService: AuthService,
    private fileUploadService: FileUploadService
  ) {}

  goBack() {
    this.location.back();
  }
  ngOnInit() {
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    const uid = this.route.snapshot.paramMap.get("uuid");
    this.uid = uid;
    this.obterPlayLits();
    this.obterEstabelecimentos();
    if (this.uid) {
      this.obterPainelDeMidia(this.uid);
      this.obterPainelMidiaSalas(this.uid);
      // this.obterVideosPainelDeMidia(this.uid);
    } else {
      Swal.close();
    }
  }

  obterPainelDeMidia(id) {
    this.service
      .Get(`PainelMidia/${id}`)
      .then((res) => {
        Swal.close();
        this.loading = false;
        this.painelMidia = res;
        // if backend returned existing image names, try to build preview URLs
        if (this.painelMidia.logo_superior) {
          try {
            this.logoSuperiorPreview = `${this.global.apiUrl}Arquivo/${this.painelMidia.logo_superior}`;
            this.logoSuperiorFileName = this.painelMidia.logo_superior;
          } catch (e) {}
        }
        if (this.painelMidia.logo_inferior) {
          try {
            this.logoInferiorPreview = `${this.global.apiUrl}Arquivo/${this.painelMidia.logo_inferior}`;
            this.logoInferiorFileName = this.painelMidia.logo_inferior;
          } catch (e) {}
        }
        // this.carregarSalas();
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        this.loading = false;
        Swal.fire("Erro", `${res.error.erros[0].messagem}`, "error");
      });
  }

  obterVideosPainelDeMidia(id) {
    this.service
      .Get(`PainelMidia/${id}/ArquivoMidia`)
      .then((res) => {
        Swal.close();
        this.loading = false;
        this.videos = res["conteudo"];
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        this.loading = false;
        Swal.fire("Erro", `${res.error.erros[0].messagem}`, "error");
      });
  }

  salvar(item: any) {
    if (!item.nome) {
      Swal.fire(
        "Atenção",
        `O nome do Painel de Mídia é obrigatório`,
        "warning"
      );
      return;
    }

    if (!item.playlist_id) {
      Swal.fire(
        "Atenção",
        `A PlayList do Painel de Mídia é obrigatório`,
        "warning"
      );
      return;
    }

    const obj = {
      ativo: item.ativo,
      nome: item.nome,
      playlist_id: item.playlist_id,
      volume_video: item.volume_video ? item.volume_video : 0,
      volume_chamada: item.volume_chamada ? item.volume_chamada : 0,
      tamanho_fonte_senha: item.tamanho_fonte_senha
        ? item.tamanho_fonte_senha
        : 16,
      tamanho_fonte_segunda_linha: item.tamanho_fonte_segunda_linha
        ? item.tamanho_fonte_segunda_linha
        : 16,
      velocidade_voz: item.velocidade_voz ? item.velocidade_voz : 50,
      logo_superior: item.logo_superior || this.logoSuperiorFileName,
      logo_inferior: item.logo_inferior || this.logoInferiorFileName,
      cor_fundo: item.cor_fundo || null,
      cor_fonte: item.cor_fonte || null,
    };

    this.loading = true;
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    if (this.painelMidia.id) {
      if (!this.salasSelecionadas || this.salasSelecionadas.length === 0) {
        Swal.fire(
          "Atenção",
          `Você precisa selecionar ao menos uma sala para continuar.`,
          "warning"
        );
        return;
      }

      const arraySalas = this.salasSelecionadas.map((id) => ({ sala_id: id }));
      this.salvarSalas(this.painelMidia.id, obj, arraySalas);
    } else {
      this.service
        .Post(`PainelMidia`, obj)
        .then((res: any) => {
          Swal.close();
          this.loading = false;
          this.obterPainelDeMidia(res.id);
          this.carregarSalas();
        })
        .catch((res) => {
          if (res.status == 401 || res.error.status == 401) {
            Swal.close();
            this.authService.logoutUser();
          }
          Swal.close();
          this.loading = false;
          Swal.fire("Erro", `${res.error.erros[0].messagem}`, "error");
        });
    }
  }

  salvarSalas(id, obj, array) {
    this.service
      .Post(`PainelMidia/${id}/Sala`, array)
      .then((res: any) => {
        Swal.close();
        this.loading = false;
        this.editarPainel(obj);
        this.fecharModal();
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        this.loading = false;
        Swal.fire("Erro", `${res.error.erros[0].messagem}`, "error");
      });
  }

  editarPainel(obj) {
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.service
      .Put(`PainelMidia/${this.painelMidia.id}`, obj)
      .then((res: any) => {
        Swal.close();
        this.loading = false;
        this.obterPainelDeMidia(res.id);
        this.obterPainelMidiaSalas(res.id);
        this.carregarSalas();
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        this.loading = false;
        Swal.fire("Erro", `${res.error.erros[0].messagem}`, "error");
      });
  }
  carregarSalas(): void {
    if (!this.painelMidia.id) return;

    this.service
      .Get(`Estabelecimento/${this.estabelecimentoId}/Sala`)
      .then((res: any) => {
        this.salasDisponiveis = res.filter((x) => x.ativo);
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        this.loading = false;
        Swal.fire("Erro", `${res.error.erros[0].messagem}`, "error");
      });
  }

  obterPlayLits() {
    this.service
      .Get(`Playlist?ativo=true`)
      .then((res) => {
        Swal.close();
        this.listaPlayLists = res["conteudo"];
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        this.loading = false;
        Swal.fire("Erro", `${res.error.erros[0].messagem}`, "error");
      });
  }

  obterEstabelecimentos() {
    this.service
      .Get(`Estabelecimento?Ativo=true`)
      .then((res) => {
        Swal.close();
        this.listaEstabelecimentos = res;
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        this.loading = false;
        Swal.fire("Erro", `${res.error.erros[0].messagem}`, "error");
      });
  }

  obterPainelMidiaSalas(id) {
    this.service
      .Get(`PainelMidia/${id}/Sala`)
      .then((res: any) => {
        Swal.close();
        this.salasSelecionadas = res["conteudo"];
        this.salasAssociadasAoPainel = res["conteudo"].filter((x) => x.ativo);
        if (this.salasSelecionadas.length > 0) {
          this.salasSelecionadas = this.salasSelecionadas.map((x) => x.sala_id);
          this.estabelecimentoId = res["conteudo"][0].estabelecimento_id;
          this.carregarSalas();
        }
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        this.loading = false;
        Swal.fire("Erro", `${res.error.erros[0].messagem}`, "error");
      });
  }

  atualizarSala(salaId: number, checked: boolean): void {
    if (checked) {
      if (!this.salasSelecionadas.includes(salaId)) {
        this.salasSelecionadas.push(salaId);
      }
    } else {
      this.salasSelecionadas = this.salasSelecionadas.filter(
        (id) => id !== salaId
      );
    }
  }
  excluirSala(sala: any) {
    Swal.fire("Favor aguarde");

    this.service
      .Delete(`PainelMidia/${this.uid}/Sala/${sala}`)
      .then((res) => {
        this.obterPainelMidiaSalas(this.uid);
        Swal.close();
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        this.loading = false;
        Swal.fire("Erro", `${res.error.erros[0].messagem}`, "error");
      });
  }
  fecharModal() {
    const modalElement = document.getElementById("salasModal");
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
  }

  onLogoSuperiorSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    const file = input.files[0];
    // preview imediata enquanto faz upload
    if (this.logoSuperiorPreview) {
      try { URL.revokeObjectURL(this.logoSuperiorPreview); } catch(e){}
    }
    this.logoSuperiorPreview = URL.createObjectURL(file);
    this.loading = true;
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    const path = `Arquivo/Upload`;
    this.fileUploadService.pushFileToStorage(path, file).then(
      (result: any) => {
        Swal.close();
        this.loading = false;
        let fileName: string | null = null;
        if (!result) {
          fileName = file.name;
        } else if (typeof result === 'string') {
          fileName = result;
        } else if (result.fileName) {
          fileName = result.fileName;
        } else if (result.nome) {
          fileName = result.nome;
        } else if (result.nome_arquivo) {
          fileName = result.nome_arquivo;
        } else if (result.error && result.error.text) {
          fileName = result.error.text;
        } else {
          fileName = file.name;
        }

        this.logoSuperiorFileName = fileName;
        this.painelMidia.logo_superior = fileName;
        
        try {
          this.logoSuperiorPreview = `${this.global.apiUrl}Arquivo/${fileName}`;
        } catch (e) {}
      },
      (err) => {
        Swal.close();
        this.loading = false;
        if (err.status == 401) {
          return;
        }
      }
    );
    input.value = "";
  }

  onLogoInferiorSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    const file = input.files[0];
    if (this.logoInferiorPreview) {
      try { URL.revokeObjectURL(this.logoInferiorPreview); } catch(e){}
    }
    this.logoInferiorPreview = URL.createObjectURL(file);
    this.loading = true;
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    const path = `Arquivo/Upload`;
    this.fileUploadService.pushFileToStorage(path, file).then(
      (result: any) => {
        Swal.close();
        this.loading = false; 
        let fileName: string | null = null;
        if (!result) {
          fileName = file.name;
        } else if (typeof result === 'string') {
          fileName = result;
        } else if (result.fileName) {
          fileName = result.fileName;
        } else if (result.nome) {
          fileName = result.nome;
        } else if (result.nome_arquivo) {
          fileName = result.nome_arquivo;
        } else if (result.error && result.error.text) {
          fileName = result.error.text;
        } else {
          fileName = file.name;
        }

        this.logoInferiorFileName = fileName;
        this.painelMidia.logo_inferior = fileName;
        try {
          this.logoInferiorPreview = `${this.global.apiUrl}Arquivo/${fileName}`;
        } catch (e) {}
      },
      (err) => {
        Swal.close();
        this.loading = false;
        if (err.status == 401) {
          return;
        }
      }
    );
    input.value = "";
  }

  onPreviewError(type: 'logoSuperior' | 'logoInferior') {
    let fileName = null;
    if (type === 'logoSuperior') {
      fileName = this.logoSuperiorFileName || this.painelMidia.logo_superior;
    } else {
      fileName = this.logoInferiorFileName || this.painelMidia.logo_inferior;
    }
    if (!fileName) return;

    const candidates = [
      `${this.global.apiUrl}Arquivo/${fileName}`,
      `${this.global.apiUrl}arquivo/${fileName}`,
      `${this.global.apiUrl}Arquivo/${fileName}`,
      `${this.global.apiUrl}arquivo/${fileName}`,
    ];

    let current = type === 'logoSuperior' ? this.logoSuperiorPreview : this.logoInferiorPreview;
    for (const c of candidates) {
      if (!current || current.indexOf(c) === -1) {
        if (type === 'logoSuperior') this.logoSuperiorPreview = c;
        else this.logoInferiorPreview = c;
        break;
      }
    }
  }
}
